"use client";

import { EmployeeInfo } from "@/modules/types/employee/employee";
import { createContext } from "react";

export const EmployeeInfoContext = createContext<EmployeeInfo | null | undefined>(undefined);
